export type ThemeColorVars =
  | "color_cta_bg"
  | "color_cta_bg_alt"
  | "color_cta_bg_hover"
  | "color_cta_bg_hover_alt"
  | "color_cta_text"
  | "color_cta_text_alt"
  | "color_checkmark_icon"
  | "color_checklist_icon"
  | "color_remove_icon"
  | "color_rating_star_icon"
  | "color_heading"
  | "color_text_body"
  | "color_text_light"
  | "color_text_white"
  | "color_accent_1"
  | "color_accent_2"
  | "color_accent_3"
  | "color_accent_4"
  | "color_bg_white"
  | "color_bg_section_light"
  | "color_bg_section_dark"
  | "color_bg_section_1"
  | "color_bg_divider"
  | "color_progress_bar_inactive"
  | "color_progress_bar_accent"
  | "color_grad_testimonial_card"
  | "color_best_value_picker_card";

export type ThemeVars = ThemeColorVars;

export const getCssVar = (name: ThemeVars, fallback?: string) => {
  return `var(--acf-${name}${fallback ? `, ${fallback}` : ""})`;
};
